import axios from './axiosbase';
import qs from 'qs';

let axiosMethod = {
  //公共异步请求;
  postServer: function(opt) {
    axios.post(opt.url, this.setData(opt)).then((response) => {
      if (opt.onSuccess) {
        opt.onSuccess(response);
      }
    }).catch(error => {
      if (opt.onFailed) {
        opt.onFailed(error);
      }
    });
  },
  // get 请求
  getServer(opt) {
    axios.get(opt.url, {
      params: this.setData(opt)
    }).then((response) => {
      if (opt.onSuccess) {
        opt.onSuccess(response);
      }
    }).catch(error => {
      if (opt.onFailed) {
        opt.onFailed(error);
      }
    });
  },
  //格式化请求参数
  setData(opt) {
    let data = {};
    if (opt.data) {
      data = opt.data;
    }
    return qs.stringify(data);
  }
}
export default axiosMethod;



// WEBPACK FOOTER //
// ./src/util/axiosUtil.js